/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliUserBasicInfoDto } from '../../models/amoxcalli-user-basic-info-dto';

export interface ApiAuthUsersIdGet$Plain$Params {
  id: string;
}

export function apiAuthUsersIdGet$Plain(http: HttpClient, rootUrl: string, params: ApiAuthUsersIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AmoxcalliUserBasicInfoDto>> {
  const rb = new RequestBuilder(rootUrl, apiAuthUsersIdGet$Plain.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AmoxcalliUserBasicInfoDto>;
    })
  );
}

apiAuthUsersIdGet$Plain.PATH = '/api/auth/users/{id}';
